// extracted by mini-css-extract-plugin
export default {"list":"styled_list_list__Nn1Jv","item":"styled_list_item__fnARd"};